enum ErrorEnum {
  UNAUTHORIZED = 'ClientAuthorizationFailedException',
  AUTHORIZED_USER_NOT_FOUND = 'InvalidActionInitiatorException',
}

export default ErrorEnum;
